import { useQuery } from "@tanstack/react-query";
import { fetchQuoteAllServices } from "../actions/fetchQuoteAllServices.actions";

export const useQuoteServicesQuery = () => {
  return useQuery({
    queryKey: ["services"],
    queryFn: async () => fetchQuoteAllServices(),
    staleTime: 1000 * 60 * 10, // 10 minutos
  });
};
